import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './assets/js/i18n'
import './assets/js/rem'
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/notify/style'
import 'vant/es/image-preview/style'
import ECharts from 'vue-echarts'
import { use } from 'echarts/core'
import VueVideoPlayer from '@videojs-player/vue'
import 'video.js/dist/video-js.css'

// 手动引入 ECharts 核心模块
import {
  CanvasRenderer
} from 'echarts/renderers'
import {
  BarChart,
  LineChart,
  PieChart
} from 'echarts/charts'
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent
} from 'echarts/components'

// 注册必须的组件
use([
  CanvasRenderer,
  BarChart,
  LineChart,
  PieChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent
])

const app = createApp(App)
// app.config.globalProperties.$isWeb = false

app.component('v-chart', ECharts)
app.use(VueVideoPlayer)
app.use(store)
app.use(i18n)
app.use(router)
app.mount('#app')
